// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.90607d61f435ccb74527.js";
	// return url for filenames based on template
	return "" + {"1167":"b60afec1c8543fc38e98","9147":"bcb97e2311157816d154"}[chunkId] + ".js";
};